export default "__VITE_ASSET__CbhedZLV__"